import { AiseaApiFactory } from "@/api/aisea/apiFactory";
const vesselReportExportApi = AiseaApiFactory.get("vesselReportExport");

export default {
  async exportReport(_, payload) {
    let resReport = await vesselReportExportApi.export(payload);
    return resReport;
  },
};
